import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Input from 'src/components/Input';
import ModernDatePicker from 'src/components/SharedComponents/ModernDatePicker/ModernDatePicker';
import CalloutCard from 'src/components/CalloutCard/CalloutCard';
import { variables } from 'src/Tenants';
import { serviceRequestTableLocalTime } from 'src/helpers/validationHelper';

interface WarrantyDetailsSectionProps {
  suiteFormData: any;
  onSetSuiteFormData: (data: any) => void;
}

const WarrantyDetailsSection = ({
  suiteFormData,
  onSetSuiteFormData,
}: WarrantyDetailsSectionProps) => {
  return (
    <>
      <h2>Warranty Details</h2>
      <Row>
        <Col xs="12" md="6">
          <ModernDatePicker
            label="Asset Warranty Default Start Date"
            labelAlign="left"
            value={
              suiteFormData.assetWarrantyDefaultStartDate
                ? new Date(
                    serviceRequestTableLocalTime(
                      suiteFormData.assetWarrantyDefaultStartDate,
                      'suiteform'
                    )
                  )
                : null
            }
            onChange={(date: Date | null) => {
              onSetSuiteFormData({ assetWarrantyDefaultStartDate: date });
            }}
          />
        </Col>
        <Col xs="12" md="6">
          <Input
            value={
              suiteFormData.warrantyNumber ? suiteFormData.warrantyNumber : ''
            }
            onChange={(e: any) =>
              onSetSuiteFormData({ warrantyNumber: e.target.value })
            }
            label="Warranty Number :"
            placeholder="Warranty Number"
            block
          />
        </Col>
      </Row>
      <CalloutCard
        icon_type="info"
        message={
          <>
            <strong>
              Adding rooms to a {variables.Suite} has been simplified.
            </strong>{' '}
            You can now add preconfigured project rooms or unique custom spaces
            directly from the <strong>'Rooms and Items'</strong> tab of the
            suite page. For bulk updates or importing unit-specific layouts,
            please refer to our updated toolkit.
          </>
        }
      />
    </>
  );
};

export default WarrantyDetailsSection;
